export enum DeployStatusResponse {
	Success,
	Error,
	Cancelled
}
